
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("1GckT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6d5250978babc23c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6jY6G = parcelRequire("6jY6G");

var $lGGIs = parcelRequire("lGGIs");

var $4R6GH = parcelRequire("4R6GH");

var $ax4F6 = parcelRequire("ax4F6");

const $6d5250978babc23c$var$AfterPaintIssuePreEval = ()=>{
    const route = (0, $6jY6G.useCurrentRoute)();
    if ((0, $ax4F6.PREEVAL_ROUTES).has(route.name) && (!(0, $4R6GH.fg)('spike_removing_lazyissueapp_from_nin_routes') || !(0, $ax4F6.EXCLUDE_PREEVAL_ROUTES).has(route.name)) && (!(0, $4R6GH.fg)('jsw-disable-issue-app-full-page-load') || !(0, $ax4F6.EXCLUDE_BOARD_BACKLOG_PREEVAL_ROUTES).has(route.name))) {
        (()=>{
            (0, $lGGIs.markAsBentoBundleReady)((parcelRequire("1yy3N")));
        })();
        performance.mark((0, $ax4F6.AFTER_PAINT_ISSUE_PREEVAL_MARK));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
};
var $6d5250978babc23c$export$2e2bcd8739ae039 = $6d5250978babc23c$var$AfterPaintIssuePreEval;

});
parcelRegister("lGGIs", function(module, exports) {

$parcel$export(module.exports, "markAsBentoBundleReady", () => $7671cdebcdce4d73$export$d9ff0b3329728986);

var $fDtbf = parcelRequire("fDtbf");

var $2SVPM = parcelRequire("2SVPM");
let $7671cdebcdce4d73$var$reportedBentoBundleReady = false;
const $7671cdebcdce4d73$export$d9ff0b3329728986 = (importedBundle)=>{
    if (!false) importedBundle.then(()=>{
        // Mutex for reporter
        if ($7671cdebcdce4d73$var$reportedBentoBundleReady) return;
        $7671cdebcdce4d73$var$reportedBentoBundleReady = true;
        (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('bento.bundle-ready', 'jira-spa.js:eval-stop');
        const resources = performance.getEntriesByType('mark');
        for(let i = resources.length - 1; i >= 0; i -= 1)if (resources[i].name.startsWith('async-issue-app') && resources[i].name.endsWith((0, $fDtbf.JS_EVAL_START))) {
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('bento.eval', resources[i].name);
            break;
        }
    });
    return importedBundle;
};

});

parcelRegister("ax4F6", function(module, exports) {

$parcel$export(module.exports, "PREEVAL_ROUTES", () => $8696c41b39bbb550$export$8411da1302b7546c);
$parcel$export(module.exports, "EXCLUDE_PREEVAL_ROUTES", () => $8696c41b39bbb550$export$bd0ce8e012b9a3e4);
$parcel$export(module.exports, "EXCLUDE_BOARD_BACKLOG_PREEVAL_ROUTES", () => $8696c41b39bbb550$export$53724bb7236bede3);
$parcel$export(module.exports, "AFTER_PAINT_ISSUE_PREEVAL_MARK", () => $8696c41b39bbb550$export$76f8f9afcfc4a896);
const $8696c41b39bbb550$export$8411da1302b7546c = new Set([
    'archived-projects-directory',
    'archived-project-direct-link',
    'boards-directory',
    'classic-business-board',
    'classic-business-board-embed',
    'classic-business-board-custom-embed',
    'classic-business-calendar',
    'classic-business-calendar-embed',
    'classic-business-form',
    'classic-business-form-submit',
    'classic-business-list',
    'classic-business-list-embed',
    'classic-business-timeline',
    'classic-business-timeline-embed',
    'connect-general',
    'connect-general-invalid',
    'connect-general-service-desk-project',
    'connect-project',
    'dashboards-directory',
    'dashboards-directory-secure',
    'filters-directory',
    'forge-spa-admin',
    'global-issue-navigator',
    'global-settings-issues-custom-fields-view',
    'global-settings-issues-fieldlayouts-view',
    'global-settings-issues-fieldlayouts-schemes-view',
    'global-settings-issues-linktypes-view',
    'global-settings-issues-notification-view',
    'global-settings-issues-permissions-schemes-view',
    'global-settings-issues-priorities',
    'global-settings-issues-resolutions',
    'global-settings-issues-security-schemes',
    'global-settings-issues-statuses',
    'global-settings-issues-field-schemes-view',
    'global-settings-issues-field-screens',
    'global-settings-issues-subtasks-manage',
    'global-settings-issues-time-tracking',
    'global-settings-issues-types-view',
    'global-settings-issues-types-schemes-manage',
    'global-settings-issues-types-screen-schemes-view',
    'global-settings-issues-workflows-pages',
    'global-settings-issues-workflows-schemes-view',
    'issue-embed',
    'knowledge-hub-all-articles',
    'knowledge-hub-article-in-category',
    'knowledge-hub-browse-all-articles',
    'knowledge-hub-browse-view-article',
    'knowledge-hub-category',
    'knowledge-hub-category-page',
    'knowledge-hub-drafts',
    'knowledge-hub-landing',
    'knowledge-hub-search',
    'knowledge-hub-setup',
    'knowledge-hub-suggested-topics',
    'opsgenie-schedule',
    'people-index',
    'personal-settings',
    'polaris-ideas',
    'products-jsw-configuration',
    'projects-directory',
    'project-components',
    'issue-navigator',
    'issue-navigator-classic',
    'issue-navigator-core',
    'project-pages',
    'project-settings-components',
    'project-settings-versions',
    'project-versions',
    'rapidboard-backlog',
    'rapidboard-board',
    'rapidboard-board-embed',
    'rapidboard-report',
    'rapidboard-user-backlog',
    'rapidboard-user-board',
    'rapidboard-user-report',
    'servicedesk-change-calendar',
    'servicedesk-cmdb-configure',
    'servicedesk-cmdb-object',
    'servicedesk-cmdb-object-schema',
    'servicedesk-connect-project',
    'servicedesk-create-project',
    'servicedesk-customers-v2',
    'servicedesk-boards',
    'servicedesk-issues',
    'servicedesk-kb-requests-reports',
    'servicedesk-kb-requests-reports-time-scale-issue',
    'servicedesk-kb-requests-reports-time-scale',
    'servicedesk-oncall-schedule',
    'servicedesk-organization_v2',
    'servicedesk-practice-custom-and-issue',
    'servicedesk-practice-edit',
    'servicedesk-practice-issue',
    'servicedesk-practice-landing',
    'servicedesk-practice-new',
    'servicedesk-queues-addon',
    'servicedesk-queues-custom-view',
    'servicedesk-queues-edit',
    'servicedesk-queues-issue',
    'servicedesk-queues-landing',
    'servicedesk-queues-new',
    'servicedesk-reports',
    'servicedesk-reports-custom',
    'servicedesk-reports-custom-create',
    'servicedesk-reports-custom-edit',
    'servicedesk-reports-custom-time-scale-issue',
    'servicedesk-reports-custom-time-scale',
    'servicedesk-reports-satisfaction',
    'servicedesk-reports-satisfaction-time-scale-issue',
    'servicedesk-reports-satisfaction-time-scale',
    'servicedesk-reports-type',
    'servicedesk-reports-workload',
    'servicedesk-services',
    'servicedesk-service-details',
    'servicedesk-sla-settings',
    'global-settings-issues-cmdb-field-config',
    'admin-oauth-credentials',
    'software-backlog',
    'software-boards',
    'software-code',
    'software-code-classic',
    'software-security',
    'software-security-classic',
    'software-deployments',
    'software-deployments-classic',
    'software-issue-navigator',
    'software-release-notes',
    'software-reports',
    'software-reports-burndown',
    'software-reports-burnup',
    'software-reports-control',
    'software-reports-cumulative',
    'software-reports-velocity',
    'software-roadmap',
    'software-roadmap-classic',
    'software-timeline',
    'software-timeline-classic',
    'system-dashboard-edit',
    'trash-projects-directory',
    'your-work'
]);
const $8696c41b39bbb550$export$bd0ce8e012b9a3e4 = new Set([
    'global-issue-navigator',
    'issue-navigator',
    'issue-navigator-classic',
    'issue-navigator-core',
    'servicedesk-issues',
    'software-issue-navigator',
    'software-timeline',
    'software-timeline-classic'
]);
const $8696c41b39bbb550$export$53724bb7236bede3 = new Set([
    'software-backlog',
    'software-boards',
    'rapidboard-backlog',
    'rapidboard-board'
]);
const $8696c41b39bbb550$export$76f8f9afcfc4a896 = 'AfterPaintIssuePreEval:rendered';

});

parcelRegister("1yy3N", function(module, exports) {

let $1223630e8b0330c9$var$load = (parcelRequire("28QjX"))(4);































module.exports = Promise.all([
    (parcelRequire("avM1e"))('memo_fix_issue_field_remounts_2', function() {
        return Promise.all([
            $1223630e8b0330c9$var$load("1oP3P")
        ]);
    }, function() {
        return Promise.all([
            $1223630e8b0330c9$var$load("9ev6R")
        ]);
    }),
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $1223630e8b0330c9$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $1223630e8b0330c9$var$load("k6g9p")
        ]);
    }),
    (parcelRequire("avM1e"))('jirt-convert-class-to-functional-component', function() {
        return Promise.all([
            $1223630e8b0330c9$var$load("1ls92")
        ]);
    }, function() {
        return Promise.all([
            $1223630e8b0330c9$var$load("kLeYK")
        ]);
    }),
    (parcelRequire("avM1e"))('redaction_onboarding_iv_llc', function() {
        return Promise.all([
            $1223630e8b0330c9$var$load("czPin")
        ]);
    }, function() {
        return Promise.all([
            $1223630e8b0330c9$var$load("iGvP4")
        ]);
    }),
    (parcelRequire("avM1e"))('jiv-20591-renderer-rerenders-fix-refactor', function() {
        return Promise.all([
            (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-small-nodes', function() {
                return Promise.all([
                    $1223630e8b0330c9$var$load("d5z58"),
                    $1223630e8b0330c9$var$load("kvRbA"),
                    $1223630e8b0330c9$var$load("ffQaD"),
                    $1223630e8b0330c9$var$load("l253H"),
                    $1223630e8b0330c9$var$load("76n7a")
                ]);
            }, function() {
                return Promise.all([
                    $1223630e8b0330c9$var$load("f771T")
                ]);
            }),
            (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-card-nodes', function() {
                return Promise.all([
                    $1223630e8b0330c9$var$load("lh7CA"),
                    $1223630e8b0330c9$var$load("kNFvF"),
                    $1223630e8b0330c9$var$load("kvRbA"),
                    $1223630e8b0330c9$var$load("ffQaD"),
                    $1223630e8b0330c9$var$load("l253H"),
                    $1223630e8b0330c9$var$load("76n7a"),
                    $1223630e8b0330c9$var$load("fliVL")
                ]);
            }, function() {
                return Promise.all([
                    $1223630e8b0330c9$var$load("jrRVX")
                ]);
            }),
            (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-media-nodes', function() {
                return Promise.all([
                    $1223630e8b0330c9$var$load("gXEyJ"),
                    $1223630e8b0330c9$var$load("kvRbA"),
                    $1223630e8b0330c9$var$load("ffQaD"),
                    $1223630e8b0330c9$var$load("l253H"),
                    $1223630e8b0330c9$var$load("76n7a")
                ]);
            }, function() {
                return Promise.all([
                    $1223630e8b0330c9$var$load("hy7ba")
                ]);
            }),
            $1223630e8b0330c9$var$load("gDexj")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-small-nodes', function() {
                return Promise.all([
                    $1223630e8b0330c9$var$load("d5z58"),
                    $1223630e8b0330c9$var$load("kvRbA"),
                    $1223630e8b0330c9$var$load("ffQaD"),
                    $1223630e8b0330c9$var$load("l253H"),
                    $1223630e8b0330c9$var$load("76n7a")
                ]);
            }, function() {
                return Promise.all([
                    $1223630e8b0330c9$var$load("f771T")
                ]);
            }),
            (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-card-nodes', function() {
                return Promise.all([
                    $1223630e8b0330c9$var$load("lh7CA"),
                    $1223630e8b0330c9$var$load("kNFvF"),
                    $1223630e8b0330c9$var$load("kvRbA"),
                    $1223630e8b0330c9$var$load("ffQaD"),
                    $1223630e8b0330c9$var$load("l253H"),
                    $1223630e8b0330c9$var$load("76n7a"),
                    $1223630e8b0330c9$var$load("fliVL")
                ]);
            }, function() {
                return Promise.all([
                    $1223630e8b0330c9$var$load("jrRVX")
                ]);
            }),
            (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-media-nodes', function() {
                return Promise.all([
                    $1223630e8b0330c9$var$load("gXEyJ"),
                    $1223630e8b0330c9$var$load("kvRbA"),
                    $1223630e8b0330c9$var$load("ffQaD"),
                    $1223630e8b0330c9$var$load("l253H"),
                    $1223630e8b0330c9$var$load("76n7a")
                ]);
            }, function() {
                return Promise.all([
                    $1223630e8b0330c9$var$load("hy7ba")
                ]);
            }),
            $1223630e8b0330c9$var$load("hyyp4")
        ]);
    }),
    (parcelRequire("avM1e"))('jira_amplitude_sr', function() {
        return Promise.all([
            $1223630e8b0330c9$var$load("8EtZR"),
            $1223630e8b0330c9$var$load("kVX56")
        ]);
    }, function() {
        return Promise.all([
            $1223630e8b0330c9$var$load("6jOz3")
        ]);
    }),
    (parcelRequire("avM1e"))('jiv-20455-dev-panel-to-sync', function() {
        return Promise.all([
            (parcelRequire("avM1e"))('jiv-20508-remove-height-animation-dev-panel', function() {
                return Promise.all([
                    $1223630e8b0330c9$var$load("hm756")
                ]);
            }, function() {
                return Promise.all([]);
            }),
            (parcelRequire("avM1e"))('create-branch-dropdown-iv-llc-dev-panel', function() {
                return Promise.all([
                    $1223630e8b0330c9$var$load("46Z1D")
                ]);
            }, function() {
                return Promise.all([
                    $1223630e8b0330c9$var$load("3DKoG")
                ]);
            }),
            (parcelRequire("avM1e"))('create-commit-dropdown-iv-llc-dev-panel', function() {
                return Promise.all([
                    $1223630e8b0330c9$var$load("cNRxo")
                ]);
            }, function() {
                return Promise.all([
                    $1223630e8b0330c9$var$load("i8oWy")
                ]);
            }),
            (parcelRequire("avM1e"))('create_pullrequest_dropdown_iv_llc_dev_panel', function() {
                return Promise.all([
                    $1223630e8b0330c9$var$load("63C5i")
                ]);
            }, function() {
                return Promise.all([
                    $1223630e8b0330c9$var$load("lbT1q")
                ]);
            }),
            (parcelRequire("avM1e"))('create_pullrequest_dropdown_iv_llc_dev_panel', function() {
                return Promise.all([
                    $1223630e8b0330c9$var$load("63C5i")
                ]);
            }, function() {
                return Promise.all([
                    $1223630e8b0330c9$var$load("lbT1q")
                ]);
            }),
            (parcelRequire("avM1e"))('ff-action-dropdown-simple-iv-llc-dev-panel', function() {
                return Promise.all([
                    $1223630e8b0330c9$var$load("lIp00")
                ]);
            }, function() {
                return Promise.all([
                    $1223630e8b0330c9$var$load("cZoU9")
                ]);
            }),
            (parcelRequire("avM1e"))('ff-action-dropdown-simple-iv-llc-dev-panel', function() {
                return Promise.all([
                    $1223630e8b0330c9$var$load("lIp00")
                ]);
            }, function() {
                return Promise.all([
                    $1223630e8b0330c9$var$load("cZoU9")
                ]);
            }),
            (parcelRequire("avM1e"))('vulnerability-dropdown-iv-llc-dev-panel', function() {
                return Promise.all([
                    $1223630e8b0330c9$var$load("dsjsy")
                ]);
            }, function() {
                return Promise.all([
                    $1223630e8b0330c9$var$load("QeZ1l")
                ]);
            }),
            $1223630e8b0330c9$var$load("ckYFZ"),
            $1223630e8b0330c9$var$load("kvRbA"),
            $1223630e8b0330c9$var$load("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $1223630e8b0330c9$var$load("etgJj")
        ]);
    }),
    (parcelRequire("avM1e"))('details_loader_to_entrypoint_iv_llc_dev_panel', function() {
        return Promise.all([
            $1223630e8b0330c9$var$load("84z1X")
        ]);
    }, function() {
        return Promise.all([
            $1223630e8b0330c9$var$load("eBkr0")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $1223630e8b0330c9$var$load("czifk")
        ]);
    }, function() {
        return Promise.all([
            $1223630e8b0330c9$var$load("kcs34")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $1223630e8b0330c9$var$load("cTJTG"),
            $1223630e8b0330c9$var$load("l253H"),
            $1223630e8b0330c9$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $1223630e8b0330c9$var$load("4Qxp7")
        ]);
    }),
    (parcelRequire("avM1e"))('fix_versions_component_perf_improvement_vc90', function() {
        return Promise.all([
            $1223630e8b0330c9$var$load("6TXdv")
        ]);
    }, function() {
        return Promise.all([
            $1223630e8b0330c9$var$load("4t8fr")
        ]);
    }),
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $1223630e8b0330c9$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $1223630e8b0330c9$var$load("7B2gt")
        ]);
    }),
    (parcelRequire("avM1e"))('improve_issue_automation_button_iv_llc', function() {
        return Promise.all([
            $1223630e8b0330c9$var$load("5VTmG")
        ]);
    }, function() {
        return Promise.all([
            $1223630e8b0330c9$var$load("6mU2N"),
            $1223630e8b0330c9$var$load("kvRbA"),
            $1223630e8b0330c9$var$load("ffQaD")
        ]);
    }),
    (parcelRequire("avM1e"))('improve_issue_view_comment_ai', function() {
        return Promise.all([
            $1223630e8b0330c9$var$load("egvYO")
        ]);
    }, function() {
        return Promise.all([
            $1223630e8b0330c9$var$load("hkt2G")
        ]);
    }),
    (parcelRequire("avM1e"))('issue_comment_reply_list_sync_import', function() {
        return Promise.all([
            $1223630e8b0330c9$var$load("eZWUu")
        ]);
    }, function() {
        return Promise.all([
            $1223630e8b0330c9$var$load("aWylw")
        ]);
    }),
    (parcelRequire("avM1e"))('link_paste_recommendations', function() {
        return Promise.all([]);
    }, function() {
        return Promise.all([
            $1223630e8b0330c9$var$load("7ClEP")
        ]);
    }),
    (parcelRequire("avM1e"))('jira-issue-view-child-issues-panel-entrypoint', function() {
        return Promise.all([
            $1223630e8b0330c9$var$load("fdfwb")
        ]);
    }, function() {
        return Promise.all([
            $1223630e8b0330c9$var$load("7TIhF")
        ]);
    }),
    $1223630e8b0330c9$var$load("7mIf9"),
    $1223630e8b0330c9$var$load("jXweD"),
    $1223630e8b0330c9$var$load("5BNUw"),
    $1223630e8b0330c9$var$load("kGAgW"),
    $1223630e8b0330c9$var$load("kVX56"),
    $1223630e8b0330c9$var$load("ffQaD"),
    $1223630e8b0330c9$var$load("kvRbA"),
    $1223630e8b0330c9$var$load("3yAl4"),
    $1223630e8b0330c9$var$load("fliVL"),
    $1223630e8b0330c9$var$load("76n7a"),
    $1223630e8b0330c9$var$load("l253H"),
    $1223630e8b0330c9$var$load("jbxE1"),
    $1223630e8b0330c9$var$load("7imUH"),
    $1223630e8b0330c9$var$load("kNFvF"),
    $1223630e8b0330c9$var$load("70aLb")
]).then(()=>parcelRequire('kW74N'));

});
parcelRegister("avM1e", function(module, exports) {
"use strict";
module.exports = function(cond, ifTrue, ifFalse) {
    return globalThis.__MCOND && globalThis.__MCOND(cond) ? ifTrue() : ifFalse();
};

});




//# sourceMappingURL=AfterPaintIssuePreEval.de610b42.js.map
